import React from "react";
import CountUp from "./Countup";

const stats = [
  { to: 50000, suffix: "+", label: "Lines of Code" },
  { to: 15, suffix: "+", label: "Projects Completed" },
  { to: 24, suffix: "+", label: "Months of Dev Experience" },
  { to: 2000, suffix: "+", label: "Cups of Coffee" },
];

export default function ExpertiseStatsSection() {
  return (
    <section className="w-full max-w-5xl mx-auto py-16 px-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white dark:bg-[#101315] border border-black/10 dark:border-white/10 rounded-lg p-6 flex flex-col items-start"
          >
            <div className="font-mono text-3xl sm:text-4xl font-medium text-accent tabular-nums">
              <CountUp to={stat.to} duration={2} separator="," />
              {stat.suffix}
            </div>
            <p className="mt-3 font-mono text-[12px] uppercase tracking-wider text-muted dark:text-pale">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
